var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDriveColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1508_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81443 18.9981L2.87285 20.7885C3.09278 21.1654 3.40893 21.4615 3.78007 21.6769L7.56014 15.2692H0C0 15.6865 0.109966 16.1038 0.329897 16.4808L1.81443 18.9981Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.73078L8.21993 1.32309C7.8488 1.53847 7.53265 1.83463 7.31271 2.21155L0.329897 14.0577C0.11401 14.4265 0.00028744 14.8441 0 15.2692H7.56014L12 7.73078Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.22 21.6769C20.5911 21.4615 20.9072 21.1654 21.1272 20.7885L21.567 20.0481L23.6701 16.4808C23.8901 16.1038 24 15.6865 24 15.2692H16.4393L18.0481 18.3654L20.22 21.6769Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.73077L15.7801 1.32308C15.409 1.10769 14.9829 1 14.543 1H9.45708C9.01722 1 8.5911 1.12115 8.21997 1.32308L12 7.73077Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4398 15.2692H7.5601L3.78003 21.6769C4.15116 21.8923 4.57728 22 5.01714 22H18.9828C19.4226 22 19.8488 21.8788 20.2199 21.6769L16.4398 15.2692Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1787 8.13463L16.6873 2.21155C16.4674 1.83463 16.1512 1.53847 15.7801 1.32309L12 7.73078L16.4399 15.2692H23.9863C23.9863 14.8519 23.8763 14.4346 23.6564 14.0577L20.1787 8.13463Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1508_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDriveColored);
export default __webpack_public_path__ + "static/media/logo-drive-colored.e60380004c05bb5c57001801e37cffca.svg";
export { ForwardRef as ReactComponent };